module.exports = __webpack_public_path__ + "static/media/notfoundv2.222fc04e.svg";